import React from 'react';
import { useTranslation } from 'react-i18next';

import { UnlinkIcon } from '@/shared/assets/icons/unlink-icon';
import { ConfirmDialog } from '@/shared/components/ui/confirm-dialog/confirm-dialog';
import { Trigger } from '@/shared/components/ui/trigger/trigger';
import { TRemoveResourcesFromGroupProps } from '@/shared/features/groups/components/remove-resources-from-group/remove-resources-from-group.types';
import { useGroupsConfig } from '@/shared/features/groups/context/groups-config-context';
import { useGroupResourceActions } from '@/shared/features/groups/hooks/use-group-resource-actions/use-group-resource-actions';
import { Can } from '@/shared/features/permissions/components/can/can';

export const RemoveResourcesFromGroup: React.FC<
  TRemoveResourcesFromGroupProps
> = ({ resources, component = 'MenuItem', onClose, onSuccess, permission }) => {
  const { t } = useTranslation();
  const { permissionActions } = useGroupsConfig();
  const { createResourceUpdatePromises } = useGroupResourceActions();

  const onDelete = async () => {
    const promises = createResourceUpdatePromises(resources, '');
    await Promise.all(promises);
  };

  const renderTriggerComponent = () => (
    <Trigger
      component={component}
      icon={<UnlinkIcon variant="error" />}
      buttonVariant="alertSecondary"
      menuItemVariant="alert"
      buttonSize="extraSmall"
      label={t('common:detach')}
    />
  );

  return (
    <Can action={permissionActions.updateGroup}>
      <ConfirmDialog
        mutation={onDelete}
        headline={t('groups:remove_selected_items_from_group')}
        triggerComponent={renderTriggerComponent()}
        primaryButtonVariant="alert"
        onClose={onClose}
        onSuccess={onSuccess}
        permission={permission}
      />
    </Can>
  );
};
